/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PhysioTherapist from './physio-therapist';
import PhysioTherapistDetail from './physio-therapist-detail';
import PhysioTherapistUpdate from './physio-therapist-update';
import PhysioTherapistDeleteDialog from './physio-therapist-delete-dialog';

const PhysioTherapistRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PhysioTherapist />} />
    <Route path="new" element={<PhysioTherapistUpdate />} />
    <Route path=":id">
      <Route index element={<PhysioTherapistDetail />} />
      <Route path="edit" element={<PhysioTherapistUpdate />} />
      <Route path="delete" element={<PhysioTherapistDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PhysioTherapistRoutes;
